import multiField from "common/bindings/multiField";
kendo.data.binders.classWhen = multiField.extend({
    bindingName: "classWhen",
    applyRefresh: function(className, value) {
        $(this.element).toggleClass(className, value);
    }
});
kendo.data.binders.classWhenNot = multiField.extend({
    bindingName: "classWhenNot",
    applyRefresh: function(className, value) {
        $(this.element).toggleClass(className, !value);
    }
});

kendo.data.binders.widget.classWhen = multiField.extend({
    bindingName: "classWhen",
    applyRefresh: function(className, value) {
        var el;
        if (this.element.wrapper) {
            el = this.element.wrapper;
        } else {
            el = this.element.element;
        }
        el.toggleClass(className, value);
    }
});

kendo.data.binders.widget.classWhenNot = multiField.extend({
    bindingName: "classWhenNot",
    applyRefresh: function(className, value) {
        var el;
        if (this.element.wrapper) {
            el = this.element.wrapper;
        } else {
            el = this.element.element;
        }
        el.toggleClass(className, !value);
    }
});